import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ROOT_URL } from "../../api/ApiConfig";

export const createExternalKbFeedback = createAsyncThunk(
    "externalKbFeedback/createExternalKbFeedback",
    async (feedbackData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${ROOT_URL}/kb/feedback`,
                feedbackData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    success: false,
    data: null,
};

const createExternalKbFeedbackSlice = createSlice({
    name: "createExternalKbFeedback",
    initialState,
    reducers: {
        resetCreateExternalKbFeedbackState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createExternalKbFeedback.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(createExternalKbFeedback.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.data = action.payload;
            })
            .addCase(createExternalKbFeedback.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            });
    },
});

export const { resetCreateExternalKbFeedbackState } =
    createExternalKbFeedbackSlice.actions;
export default createExternalKbFeedbackSlice.reducer;
